import request from "@/utils/request";
import { initGetParams } from "@/utils/index";

/**
 * 最近融资
 * @param data
 * @returns {*}
 */
export function getRecentlyOrder(data) {
  return request({
    url: `/credit/productOrder/2001048010?${initGetParams(data)}`,
    method: "get",
  });
}



/**
 * 我的放贷交易
 * @param data
 * @returns {*}
 */
export function getStaging(data) {
  return request({
    url: "/credit/financialProduct/2001046008",
    method: "get",
    params: data,
  });
}


//金融产品分页
export function getProductPage(data) {
  return request({
    url: "/credit/financialProduct/2001046004",
    method: "get",
    params: data,
  });
}

/**
 * 金融产品增加
 * @param data
 * @returns {*}
 */
export function addProduct(data) {
  return request({
    url: "/credit/financialProduct/2001046001",
    method: "post",
    data: data,
  });
}

/**
 * 金融产品修改
 * @param data
 * @returns {*}
 */
export function editProduct(data) {
  return request({
    url: "/credit/financialProduct/2001046003",
    method: "post",
    data: data,
  });
}

/**
 * 金融产品删除
 * @param data
 * @returns {*}
 */
export function deleteProduct(data) {
  return request({
    url: "/credit/financialProduct/2001046002",
    method: "post",
    data: data,
  });
}




/**
 * 我的放贷交易
 * @param data
 * @returns {*}
 */
export function getProductOrder(data) {
  return request({
    url: "/credit/productOrder/2001048002",
    method: "get",
    params: data,
  });
}

/**
 * 金融机构审核通过/不通过
 * @param data
 * @returns {*}
 */
export function financialExamine(data) {
  return request({
    url: "/credit/productOrder/2001048004",
    method: "post",
    data: data,
  });
}

/**
 * 金融机构授信通过/不通过
 * @param data
 * @returns {*}
 */
export function financialCredit(data) {
  return request({
    url: "/credit/productOrder/2001048005",
    method: "post",
    data: data,
  });
}

/**
 * 金融机构授信通过/不通过
 * @param data
 * @returns {*}
 */
export function financialContract(data) {
  return request({
    url: "/credit/productOrder/2001048007",
    method: "post",
    data: data,
  });
}

/**
 * 金融机构详情
 * @param data
 * @returns {*}
 */
export function getFinancialInsDetails(data) {
  return request({
    url: `/credit/financialInstitution/2001152005?${initGetParams(data)}`,
    method: "get",
  });
}


/**
 * 订单详情
 * @param data
 * @returns {*}
 */
export function getDetails(data) {
  return request({
    url: `/credit/productOrder/2001048009?${initGetParams(data)}`,
    method: "get",
  });
}



/**
 * 企业信用查询
 * @param data
 * @returns {*}
 */
export function getEnterpriseClient(data) {
  return request({
    url: "/credit/enterpriseClient/2001049003",
    method: "get",
    params: data,
  });
}

//导出企业详细信息
export function getDetailsExport(data) {
  return request({
    url: `/credit/enterprise/2001050004/exportDetail`,
    method: "get",
    params: data,
  });
}

/**
 * 修改
 * @param data
 * @returns {*}
 */
export function editFinaInstitution(data) {
  return request({
    url: "/credit/financialInstitution/2001047003",
    method: "post",
    data: data,
  });
}





